import { useState } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'store';
import { MenuItemContainer, MenuContainer, SubBoxContainer } from './UserTypeListStyled';
import StorageRoundedIcon from '@mui/icons-material/StorageRounded';
import CheckIcon from '@mui/icons-material/Check';
import { dispatch } from 'store';
import { reflectSidebar, setUserType } from 'store/actions/zignaAi';
import { useNavigate } from 'react-router-dom';
import { userTypes } from 'config';
import { switchDB } from 'services/auth';
import { AUTH_ACTIONS } from 'config';
import authAxios from 'utils/authAxios';
import _ from 'lodash';
import { getMonthFromString, getYearFromString } from 'utils/utilities';

const UserTypeList = ({ source }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const userType = localStorage.getItem('userType');
  const { currentUser, permission } = useSelector((state) => state.auth);
  const { changeSidebar } = useSelector((state) => state.zignaAi);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const menuItemClick = (event) => {
    const userTypeMapping = {
      Professional: 'professional',
      Ancillary: 'ancillary',
      Facility: 'facility',
      'Data Audit Report': 'dataAuditReport'
    };

    const redirectMapping = {
      professional: '/v1/',
      ancillary: '/',
      facility: '/',
      dataAuditReport: '/payer-scorecard'
    };

    const selectedUserType = userTypeMapping[event];
    if (!selectedUserType) return;

    localStorage.setItem('userType', selectedUserType);
    dispatch(setUserType({ userType: selectedUserType }));

    const hasPermission = permission.some(
      (item) => item.module === selectedUserType && (selectedUserType === 'dataAuditReport' || item.perm_name === 'competitive_landscape')
    );

    if (hasPermission) {
      window.location.href = redirectMapping[selectedUserType];
    } else {
      navigate('/maintenance/404');
    }

    dispatch(reflectSidebar({ changeSidebar: !changeSidebar }));
    setAnchorEl(null);
  };

  const handleDBChange = (dbname) => {
    const currentUserLS = JSON.parse(localStorage.getItem('currentUser'));
    switchDB(currentUser.token, dbname)
      .then((res) => {
        authAxios.defaults.headers.common.Authorization = `Bearer ${res.data.serviceToken}`;
        dispatch({
          type: AUTH_ACTIONS.UPDATE_AUTH,
          payload: {
            db_name: dbname,
            serviceToken: res.data.serviceToken,
            currentUser: {
              ...currentUser,
              ...currentUserLS,
              db_name: dbname,
              token: res.data.token
            }
          }
        });
        localStorage.setItem('serviceToken', res.data.serviceToken);
        localStorage.setItem('currentUser', JSON.stringify({ ...currentUser, ...currentUserLS, db_name: dbname, token: res.data.token }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const hasPermisson = (item) => {
    const formattedItem = item.toLowerCase().replace(/\s+/g, '');
    return permission.some((perm) => perm.module.toLowerCase() === formattedItem);
  };

  return (
    <Box sx={{ padding: '0 12px' }}>
      <SubBoxContainer
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {source === 'userList' ? (
          <svg className="mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18 20L17.2929 20.7071L18 21.4142L18.7071 20.7071L18 20ZM13 4C12.4477 4 12 4.44771 12 5C12 5.55229 12.4477 6 13 6L13 4ZM13.2929 16.7071L17.2929 20.7071L18.7071 19.2929L14.7071 15.2929L13.2929 16.7071ZM18.7071 20.7071L22.7071 16.7071L21.2929 15.2929L17.2929 19.2929L18.7071 20.7071ZM19 20L19 9L17 9L17 20L19 20ZM14 4L13 4L13 6L14 6L14 4ZM19 9C19 6.23858 16.7614 4 14 4L14 6C15.6569 6 17 7.34315 17 9L19 9Z"
              fill="#33363F"
            />
            <path
              d="M6 4L6.70711 3.29289L6 2.58579L5.29289 3.29289L6 4ZM11 20C11.5523 20 12 19.5523 12 19C12 18.4477 11.5523 18 11 18L11 20ZM10.7071 7.29289L6.70711 3.29289L5.29289 4.70711L9.29289 8.70711L10.7071 7.29289ZM5.29289 3.29289L1.29289 7.29289L2.70711 8.70711L6.70711 4.70711L5.29289 3.29289ZM5 4L5 15L7 15L7 4L5 4ZM10 20L11 20L11 18L10 18L10 20ZM5 15C5 17.7614 7.23858 20 10 20L10 18C8.34315 18 7 16.6569 7 15L5 15Z"
              fill="#33363F"
            />
          </svg>
        ) : (
          <StorageRoundedIcon />
        )}
        <b>
          {' '}
          {source === 'userList'
            ? `${
                userType === 'professional'
                  ? 'Professional'
                  : userType === 'ancillary'
                  ? 'Ancillary'
                  : userType === 'dataAuditReport'
                  ? 'Data Audit Report'
                  : 'Facility'
              } - Switch To Other Views`
            : `${(currentUser?.perms?.dblist || []).find((db) => db.dbname === currentUser?.db_name)?.label} - Switch To Other DB`}
        </b>
      </SubBoxContainer>
      <MenuContainer
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        {' '}
        {source === 'userList'
          ? userTypes.map((type, index) => (
              <MenuItemContainer disabled={!hasPermisson(type)} key={index} onClick={() => menuItemClick(type)}>
                {type}
              </MenuItemContainer>
            ))
          : _.orderBy(
              currentUser?.perms?.dblist || [],
              [(i) => getYearFromString(i.label), (i) => getMonthFromString(i.label)],
              ['asc', 'asc']
            ).map((db, index) => (
              <MenuItemContainer key={index} onClick={() => handleDBChange(db?.dbname)}>
                {db.dbname === currentUser?.db_name ? <CheckIcon sx={{ marginRight: '0.5rem !important' }} /> : null}
                {db.label}
              </MenuItemContainer>
            ))}
      </MenuContainer>
    </Box>
  );
};

export default UserTypeList;
